export function setItem(key, val) {
  sessionStorage.setItem(key, JSON.stringify(val));
}

export function getItem(key) {
  const obj = JSON.parse(sessionStorage.getItem(key));
  return obj;
}

export function removeItem(key) {
  sessionStorage.removeItem(key);
}
